import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import GeneralTrackingTrackUsageAnalyticsHoverWrapper from 'lumen/components/general/tracking/track-usage-analytics-hover-wrapper';
import HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipBody from 'lumen/components/hotel/benchmark-insight/tooltips/sync-status/beni-data-sync-status-tooltip-body';
import HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeader from 'lumen/components/hotel/benchmark-insight/tooltips/sync-status/beni-data-sync-status-tooltip-header';
import type { DataSyncStatusItem } from 'lumen/utils/constants/benchmark-insight/beni-data-sync-constant-values';

interface HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipSignature {
  Args: {
    allDataSetsInSync: boolean;
    frequencyMessage: string;
    headerText: string;
    items: DataSyncStatusItem[];
  };
}

const HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltip =
  <template>
    <span class="data-sync-status" data-test-id="data-sync-status">
      <GeneralTrackingTrackUsageAnalyticsHoverWrapper
        @eventName="Sync Status Viewed"
        @properties={{hash eventTrigger="filter-bar"}}
      >
        <HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipHeader
          @allDataSetsInSync={{@allDataSetsInSync}}
          @text={{@headerText}}
        />
      </GeneralTrackingTrackUsageAnalyticsHoverWrapper>

      <EmberTooltip
        @side="bottom"
        @tooltipClass="default-tooltip default-tooltip--large data-sync-status__tooltip"
      >
        <table
          class="tooltip-table default-table data-sync-status__tooltip__table
            {{if @allDataSetsInSync 'in-sync' ''}}"
        >
          <tbody>
            {{#each @items as |item|}}
              <HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipBody
                @item={{item}}
              />
            {{/each}}
          </tbody>
        </table>

        {{#unless @allDataSetsInSync}}
          <div class="data-sync-status__tooltip__frequency">
            {{@frequencyMessage}}
          </div>
        {{/unless}}
      </EmberTooltip>
    </span>
  </template> satisfies TOC<HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltipSignature>;

export default HotelBenchmarkInsightTooltipsSyncStatusBeniDataSyncStatusTooltip;
